import { isApiFormError, isFieldErrorResponse } from '../../types';

export const extractErrorMessage = (error: unknown) => {
  const isDefaultError = isApiFormError(error);

  if (isDefaultError) {
    return error.response.data.detail;
  }

  const isFieldError = isFieldErrorResponse(error);
  if (isFieldError) {
    const errors = Object.values(error.response.data).join(', ');
    return errors;
  }

  return undefined;
};
